import React from 'react';
import { Checkbox, List } from 'antd';
import type { CheckboxChangeEvent } from 'antd/lib/checkbox';

interface SegmentItemProps {
	label: string;
	segmentId: string;
	checked: boolean;
	disabled: boolean;
	onToggle: (isChecked: boolean, segmentId: string) => void;
}

export function SegmentItem({
	label,
	segmentId,
	checked,
	disabled,
	onToggle
}: Readonly<SegmentItemProps>): JSX.Element {
	function handleChange(event: CheckboxChangeEvent): void {
		onToggle(event.target.checked, segmentId);
	}

	return (
		<List.Item>
			<Checkbox checked={checked} disabled={disabled} onChange={handleChange}>
				{label}
			</Checkbox>
		</List.Item>
	);
}
